import axios from '../../../axiosConfig';

export async function logoutUser(config = {}) {
    return await axios.get(`/logout`, config);
}

const functions = { logoutUser }
export default functions